// extracted by mini-css-extract-plugin
export default {"body":"NotValidCookie_body__0bn8w","notfound":"NotValidCookie_notfound__l7YXo","notfound404":"NotValidCookie_notfound404__alP2g","button":"NotValidCookie_button__34+Hk"};